module.exports = __webpack_public_path__ + "static/jan_1c-1ed18c581d2af0770ce63c90bf6ee1f3.mp4";